/**
 * base on application/models/Checkout.php
 */
export const CHECKOUT_METHOD = {
  PAYPAL: 'paypal',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  DISCOVER: 'discover',
  AMEX: 'amex',
  STORED_CREDIT_CARD: 'storedcreditcard',
};

/**
 * base on application/models/Checkout.php
 */
export const CHECKOUT_PRODUCT = {
  INBOUNDS_5: 1,
  FILES_ACCESS: 2,
  PREMIUM: 3,
  PREMIUM_WITH_PREPARATORY: 4,
  PREPARATORY_FOR_PREMIUM: 5,
  RESTRICTED_FIRMS_JOB_CREDITS: 6,
  RESTRICTED_FIRMS_JOB_CREDITS_3: 7,
};
